// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import elementUI from 'element-ui'
import VueAMap from 'vue-amap' // 高德地图
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Router from 'vue-router'
import VideoPlayer from 'vue-video-player'




import 'videojs-contrib-hls'

import './styles/reset.css'
import './styles/common.less'
import './styles/class-flex.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.css'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')



Vue.config.productionTip = false
Vue.use(elementUI)
Vue.use(VueAMap)
Vue.use(VueAwesomeSwiper)
Vue.use(VideoPlayer)


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


// 高德地图初始化
VueAMap.initAMapApiLoader({
  key: '2156a7f260c3aa02e258c6dd17ec13af',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js